import { langTypes } from '../settings/types'

const initialState = []

const langsReducer = (state = initialState, action) => {
    switch (action.type) {
        case langTypes.register:
            return [ ...action.payload ]
        case langTypes.clearLangs:
            return initialState
        default:
            return state
    }
}

export default langsReducer